<script setup lang="ts">
const emit = defineEmits(["close"]);
const { createAuthAttemptAndRedirect } = useAuthController();
const { toaster } = useToaster();
const route = useRoute();

const openOAuth = (type: string) => {
  const redirect = route.query.redirect as string;
  createAuthAttemptAndRedirect(type, getCurrentFullPath(redirect));
  emit("close");
};

onMounted(() => {
  toaster("warn", "sessionExpired");
});
</script>
<template>
  <BaseLayoutModal width="medium" @close="$emit('close')">
    <template #header>
      {{ $t("main.modalForcedLogout.automaticSignOut") }}
    </template>
    <template #content>
      <div class="flex flex-col gap-2">
        <p class="text-neutral-200 font-bold">
          {{ $t("main.modalForcedLogout.sessionExpired") }}
        </p>
        <p class="text-neutral-300">
          {{ $t("main.modalForcedLogout.securityTimeout") }}
        </p>
        <p class="text-neutral-300">
          {{ $t("main.modalForcedLogout.backToLogin") }}
        </p>
      </div>
      <div class="mt-5 mb-2 sm:mt-6 flex gap-2">
        <BaseButtonSubmit
          :text="$t('main.modalForcedLogout.backToLoginButton')"
          data-test="button-back-to-login-from-forced-logout"
          @click="openOAuth('login')" />
        <BaseButtonCancel
          :text="$t('main.modalForcedLogout.close')"
          data-test="button-cancel-forced-logout"
          @click="emit('close')" />
      </div>
    </template>
  </BaseLayoutModal>
</template>
